import { getStateFilterFields, correctFilterItems } from '@/services/grid-handler';
import {
  canHideChooserColumn,
  getColumnId,
  getChooserColumns,
  getMergedSortedColumns,
  mergeMissingColumns
} from '@/components/column-chooser/grid-columns';

export const DataDrid = {
    data() {
      return {
        updateFilterTimeout: 1700,
        gridInstance: null,
        gridStateKey: null,
        columns: [],
        visible: false,
        pageSize: [20, 50, 100],
        fitToPageHeightButtonRenderId: 0
      }
    },
    beforeDestroy() {
      this.fitToPageHeightButtonRenderId += 1;
    },
    methods: {
      // TODO рефактор
      initializedGrid(e) {
        this.gridInstance = e.component;
  
        setTimeout(() => {
          const optionGrid = {
            cellHintEnabled: true,
            hoverStateEnabled: true,
            columnMinWidth: 50,
            allowColumnReordering: true,
            allowColumnResizing: true,
            columnResizingMode: 'widget'
          };
          this.gridInstance.option(optionGrid);
          this.gridInstance.option('stateStoring', { ignoreColumnOptionNames: [] });
        });
      },
      applyFilterRowTimeout(e) {
        if (e.parentType === "filterRow") {
          e.updateValueTimeout = this.updateFilterTimeout;
        }
      },
      countRows(availableHeight) {
        const rowHeight = 34; // высота одной строки
        const rows = Math.floor((availableHeight || 300) / rowHeight);
  
        return rows >= 1 ? rows : 1;
      },
      stateLoad() {
        let state = this.$store.getters.gridsStates;
        if (state && state[this.gridStateKey])
          state = this.$store.getters.gridsStates[this.gridStateKey];
        else
          state = {
            pageIndex: 0,
            pageSize: this.countRows(this.gridBodyHeight)
          };
  
        state = this.normalizeGridState(state);
        state.pageSize = state.pageSize === 0 ? this.countRows(this.gridBodyHeight) : state.pageSize;

        return state;
      },
      normalizeGridState(state, currentColumns = this.getCurrentGridColumns()) {
        const normalizedState = Object.assign({}, state || {});
        currentColumns = Array.isArray(currentColumns) ? currentColumns : [];

        if (currentColumns.length === 0) {
          return normalizedState;
        }

        const stateColumns = Array.isArray(normalizedState.columns) ? normalizedState.columns : [];
        const currentColumnsByDataField = new Map();
        const stateColumnsByDataField = new Map();
        const currentDataFields = [];

        currentColumns.forEach(column => {
          if (column && column.dataField) {
            currentColumnsByDataField.set(column.dataField, column);
            currentDataFields.push(column.dataField);
          }
        });

        stateColumns.forEach(column => {
          if (column && column.dataField) {
            stateColumnsByDataField.set(column.dataField, column);
          }
        });

        let fieldsFilterValue = [];
        if (normalizedState.filterValue)
          fieldsFilterValue = getStateFilterFields(normalizedState.filterValue);
  
        const differenceStateFilterValue = fieldsFilterValue.filter(el => {
          return currentDataFields.indexOf(el.fieldName) === -1;
        });
  
        if (differenceStateFilterValue.length > 0) {
          const removableFields = differenceStateFilterValue.map(el => el.fieldName);
          normalizedState.filterValue = correctFilterItems(normalizedState.filterValue, removableFields);
        }
  
        if (stateColumns.length > 0) {
          const normalizedColumns = stateColumns.reduce((columns, stateColumn) => {
            if (!stateColumn) {
              return columns;
            }

            if (!stateColumn.dataField) {
              columns.push(stateColumn);
              return columns;
            }

            const currentColumn = currentColumnsByDataField.get(stateColumn.dataField);
            if (currentColumn) {
              columns.push({...currentColumn, ...stateColumn});
            }

            return columns;
          }, []);

          currentColumns.forEach(currentColumn => {
            if (currentColumn && currentColumn.dataField && !stateColumnsByDataField.has(currentColumn.dataField)) {
              normalizedColumns.push(currentColumn);
            }
          });

          normalizedState.columns = normalizedColumns;
        }

        return normalizedState;
      },
      getCurrentGridColumns() {
        const grid = this.gridInstance || (this.$refs.dataGrid && this.$refs.dataGrid.instance);
        return grid && grid.option ? grid.option('columns') || [] : [];
      },
      stateSave(state) {
        return this.$store.commit('setGridsStates', { key: this.gridStateKey, state: state});
      },
      addFitToPageHeightButton(e) {
        const renderId = this.fitToPageHeightButtonRenderId + 1;

        this.fitToPageHeightButtonRenderId = renderId;

        this.$nextTick(() => {
          if (renderId !== this.fitToPageHeightButtonRenderId || !e || !e.component) {
            return;
          }

          const grid = e.component;
          const gridElement = grid.element && grid.element();
          const rootElement = gridElement && gridElement.get ? gridElement.get(0) : gridElement || e.element;

          if (!rootElement || !rootElement.querySelector || !document.body.contains(rootElement)) {
            return;
          }

          const pagerHtml = rootElement.querySelector('.dx-page-sizes');

          if (!pagerHtml) {
            return;
          }

          const pageSize = grid.state().pageSize;
  
          // добавить заголовок "Размер строки"
          const pagerTitle = pagerHtml.querySelector("div:first-child");

          if (!pagerTitle || pagerTitle.innerHTML !== `${this.$t('general.rowSize')}:`) {
            const title = document.createElement('div');
            title.innerHTML = `${this.$t('general.rowSize')}:`;
            title.style.marginRight = '3px';
            pagerHtml.prepend(title);
          }
  
          // кнопка "По высоте страницы"
          const heightButton = document.createElement('div');
          heightButton.className = (!this.pageSize.includes(pageSize) && pageSize !== 0)
            ? 'dx-page-size dx-selection'
            : 'dx-page-size';
          heightButton.style.cursor = 'pointer';
          heightButton.innerHTML = this.$t('general.pageHeight');
  
          heightButton.onclick = (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();

            if (renderId !== this.fitToPageHeightButtonRenderId) {
              return;
            }

            // Берём высоту таблицы из вычисляемого свойства
            const height = this.gridBodyHeight;

            // Вычисляем количество строк
            const count = this.countRows(height);
  
            grid.pageSize(count);
            grid.repaint();
          };
  
          // удаляем старую кнопку, если уже была
          pagerHtml.querySelectorAll('.dx-page-size').forEach(btn => {
            if (btn.textContent.trim() === this.$t('general.pageHeight')) {
              btn.remove();
            }
          });
  
          heightButton.classList.add('custom-height');
          pagerHtml.appendChild(heightButton);
        });
      },
      onFilterClear() {
        this.dataGrid.clearFilter();
      },
      addMenuItems(e) {
        if (!e || e.target !== 'header') {
          return;
        }

        // идентификатор выбранного столбца
        const columnId = getColumnId(e.column);

        if (!columnId) {
          return;
        }

        const grid = e.component || this.gridInstance;

        if (!grid) {
          return;
        }

        if (!e.items) e.items = [];

        // отображение скрытых столбцов
        e.items.push({
          icon: 'selectall',
          text: this.$t('general.showAllColumns'),
          onItemClick: () => {
            const columns = mergeMissingColumns(getMergedSortedColumns(grid), this.columns);
            const hiddenColumns = getChooserColumns(columns)
              .filter((column) => !column.visible);

            if (hiddenColumns.length === 0) {
              return;
            }

            const hiddenColumnIds = new Set(hiddenColumns.map((column) => getColumnId(column)));

            grid.beginUpdate();

            try {
              hiddenColumns.forEach((column) => {
                grid.columnOption(getColumnId(column), 'visible', true);
              });
            } finally {
              grid.endUpdate();
            }

            this.columns = getChooserColumns(columns.map((column) => {
              if (!hiddenColumnIds.has(getColumnId(column))) {
                return column;
              }

              return {
                ...column,
                visible: true,
              };
            }));
          }
        });

        // скрывает выбранный столбец в выпадающем списке
        e.items.push({
          icon: 'deletecolumn',
          text: this.$t('general.hideColumn'),
          onItemClick: () => {
            const columns = mergeMissingColumns(getMergedSortedColumns(grid), this.columns);
            const targetColumn = columns.find((column) => getColumnId(column) === columnId);

            if (!canHideChooserColumn(columns, columnId)) {
              return;
            }

            // изменяет только целевой столбец, а не весь массив столбцов
            grid.beginUpdate();

            try {
              grid.columnOption(columnId, 'sortOrder', null);
              grid.columnOption(columnId, 'visible', false);
            } finally {
              grid.endUpdate();
            }

            this.columns = getChooserColumns(mergeMissingColumns(columns, [
              {
                ...targetColumn,
                sortOrder: null,
                visible: false,
              }
            ]).map((column) => {
              if (getColumnId(column) !== columnId) {
                return column;
              }

              return {
                ...column,
                sortOrder: null,
                visible: false,
              };
            }));
          }
        });

        // окно выбора columnChooser, отображает текущие столбцы грида
        e.items.push({
          icon: 'columnchooser',
          text: this.$t('general.columnChooser'),
          onItemClick: () => {
            this.columns = getChooserColumns(mergeMissingColumns(getMergedSortedColumns(grid), this.columns));
            this.visible = true;
          }
        });
      },
      async onApply(changes) {
        if (!this.gridInstance || changes.length === 0) {
          return;
        }

        // позволяют избежать пересчета и перерисовки сетки после каждого элемента
        this.gridInstance.beginUpdate();

        try {
          changes.forEach((change) => {
            const columnId = getColumnId(change);

            if (!columnId) {
              return;
            }

            // обновляет только измененный столбец, а не заменяйте весь массив столбцов
            this.gridInstance.columnOption(columnId, 'visible', change.visible);
          });
        } finally {
          this.gridInstance.endUpdate();
        }

        // после применения изменений DevExtreme обновите состояние окна выбора, используя фактическое состояние грида
        this.columns = getChooserColumns(mergeMissingColumns(getMergedSortedColumns(this.gridInstance), this.columns));
      },
      onHiding() {
        this.visible = false;
      },
    }
}